import AxiosManager from "../../../util/axiosLib/axiosManager";
import apiManager from "@/taylorCommon/apiManager";


var apiUrl=process.env.VUE_APP_apiUrl +"/";
// var apiUrl="http://127.0.0.1:8000/";
// var apiUrl= "https://kianseng.org/"
// var apiPathBase="api/test/";
var apiPathBase="api/firegods/";
// var apiPathBase="api/admin/";





export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },

    // api_Test ( data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    // },
    // api_Upload (file, data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_UpdateFile("upload",file,data)
    // },

    //---------------------------------------


    api_Admin_ChangePwd (pwdCurrent,pwdNew)
    {
        let data={
            pwdCurrent:pwdCurrent,
            pwdNew:pwdNew
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ChangePwd",data)
    },


    api_Admin_EventDefine_Query ()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine_Query",data)
    },

    api_Admin_EventDefine_Save (datas)
    {
        let data={
            json:JSON.stringify(datas)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine_Save",data)
    },

    api_Admin_EventItems_Query ( questionSystemId)
    {
        let data={
            questionSystemId:questionSystemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventItems_Query",data)
    },
    api_Admin_EventItems_ChangeStaus ( eventItem_id,status)
    {
        let data={
            eventItem_id:eventItem_id,
            status:status,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventItems_ChangeStaus",data)
    },

    api_Admin_EventItems_Delete ( eventItem_id)
    {
        let data={
            eventItem_id:eventItem_id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventItems_Delete",data)
    },

    api_Admin_EventApplicants_Query ( eventItem_id)
    {
        let data={
            eventItem_id:eventItem_id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventApplicants_Query",data)
    },

    api_Admin_EventApplicants_Delete ( eventApplicant_id)
    {
        let data={
            eventApplicant_id:eventApplicant_id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventApplicants_Delete",data)
    },


    api_Admin_EventApplicants2_Query ( eventItem_id)
    {
        let data={
            eventItem_id:eventItem_id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventApplicants2_Query",data)
    },

    api_Admin_EventApplicants2_Delete ( eventApplicant_id)
    {
        let data={
            eventApplicant_id:eventApplicant_id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventApplicants2_Delete",data)
    },


}
